import { render, staticRenderFns } from "./SortOrderCustomHelpList.vue?vue&type=template&id=04e5ae9b&"
import script from "./SortOrderCustomHelpList.vue?vue&type=script&lang=js&"
export * from "./SortOrderCustomHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports